import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api';

export default function EmpresaPerfil() {
  const [form, setForm] = useState(null);
  const [logoArchivo, setLogoArchivo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    api.get('/empresa/').then((res) => setForm(res.data));
  }, []);

  function set(campo) {
    return (e) => setForm((f) => ({ ...f, [campo]: e.target.value }));
  }

  function handleLogo(e) {
    const archivo = e.target.files?.[0];
    if (!archivo) return;
    setLogoArchivo(archivo);
    setLogoPreview(URL.createObjectURL(archivo));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setGuardando(true);
    try {
      const datos = new FormData();
      datos.append('nombre', form.nombre);
      datos.append('ruc', form.ruc || '');
      datos.append('direccion', form.direccion || '');
      datos.append('telefono', form.telefono || '');
      datos.append('email', form.email || '');
      datos.append('siguiente_numero_comprobante', form.siguiente_numero_comprobante || 1);
      if (logoArchivo) datos.append('logo', logoArchivo);

      const res = await api.patch('/empresa/', datos, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm(res.data);
      setLogoArchivo(null);
      toast.success('Datos de la empresa actualizados.');
    } catch (err) {
      const detalle = err.response?.data;
      const mensaje = detalle ? Object.values(detalle).flat().join(' ') : 'No se pudo guardar.';
      toast.error(mensaje);
    } finally {
      setGuardando(false);
    }
  }

  if (!form) return <p>Cargando…</p>;

  return (
    <div className="control-group empresa-perfil">
      <h4>Datos de la empresa</h4>
      <p className="ayuda">
        Estos datos aparecen en el Comprobante de Egreso — útil si manejás varias empresas, para identificar rápido en cuál estás trabajando.
      </p>

      <form onSubmit={handleSubmit}>
        <label>Logo</label>
        <div className="logo-uploader">
          {(logoPreview || form.logo) && (
            <img src={logoPreview || form.logo} alt="Logo de la empresa" className="logo-preview" />
          )}
          <input type="file" accept="image/*" onChange={handleLogo} />
        </div>

        <label>Razón social</label>
        <input value={form.nombre} onChange={set('nombre')} required />

        <div className="coord-inputs">
          <div>
            <label>RUC</label>
            <input value={form.ruc} onChange={set('ruc')} maxLength={13} />
          </div>
          <div>
            <label>Teléfono</label>
            <input value={form.telefono} onChange={set('telefono')} />
          </div>
        </div>

        <label>Dirección</label>
        <input value={form.direccion} onChange={set('direccion')} />

        <label>Email de contacto</label>
        <input type="email" value={form.email} onChange={set('email')} />

        <label>Próximo número de comprobante de egreso</label>
        <input
          type="number"
          min="1"
          value={form.siguiente_numero_comprobante}
          onChange={set('siguiente_numero_comprobante')}
        />
        <p className="ayuda">
          Ajusta este número solo si tu empresa ya venía numerando comprobantes en otro sistema y quieres continuar la secuencia. El próximo cheque que se solicite tomará este número.
        </p>

        <button className="btn-primary" type="submit" disabled={guardando}>
          {guardando ? 'Guardando…' : 'Guardar datos de la empresa'}
        </button>
      </form>
    </div>
  );
}
